(function () {
  'use strict';

  function initPackageProtectionInfo() {
    const ppName = document.querySelector('.cd-pp-name');
    if (!ppName) return;

    if (ppName.querySelector('.cd-pp-info-btn')) return;

    const infoBtn = document.createElement('button');
    infoBtn.type = 'button';
    infoBtn.className = 'cd-pp-info-btn';
    infoBtn.setAttribute('aria-label', 'More information about package protection');
    infoBtn.innerHTML = 'i';

    ppName.appendChild(infoBtn);

    if (!document.getElementById('cd-pp-info-modal')) {
      const modal = document.createElement('div');
      modal.id = 'cd-pp-info-modal';
      modal.className = 'cd-pp-modal';
      modal.setAttribute('aria-hidden', 'true');
      modal.innerHTML = `
        <div class="cd-pp-modal__backdrop" data-pp-modal-close></div>
        <div class="cd-pp-modal__dialog" role="dialog" aria-modal="true" aria-label="Package Protection information">
          <button type="button" class="cd-pp-modal__close" aria-label="Close" data-pp-modal-close>
            <svg width="18" height="18" viewBox="0 0 15 15" fill="none" aria-hidden="true">
              <path d="M1 1L14 14M14 1L1 14" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/>
            </svg>
          </button>

          <div class="cd-pp-modal__logo">
            <img
              src="https://data.getredo.com/redo/transparent_logo_moving_1e73603a5c04.gif"
              alt="Redo"
              loading="lazy"
            >
          </div>

          <h3 class="cd-pp-modal__title">Checkout with confidence</h3>
          <p class="cd-pp-modal__subtitle">
            Shop with confidence, knowing your purchases are protected every step of the way.
          </p>

          <div class="cd-pp-modal__list">
            <div class="cd-pp-modal__item">
              <div class="cd-pp-modal__icon">
                <svg width="32" height="32" viewBox="0 0 36 36" fill="none" aria-hidden="true">
                  <g filter="url(#ppf1)">
                    <path d="M2.5 7C2.5 3.96243 4.96243 1.5 8 1.5H28C31.0376 1.5 33.5 3.96243 33.5 7V27C33.5 30.0376 31.0376 32.5 28 32.5H8C4.96243 32.5 2.5 30.0376 2.5 27V7Z" stroke="#D6D6D6"/>
                    <path d="M19.3333 23.6667C19.3333 23.6667 19.8995 23.5858 22.2426 21.2426C24.5858 18.8995 24.5858 15.1005 22.2426 12.7574C21.4125 11.9272 20.3995 11.3911 19.3333 11.1492M19.3333 23.6667H23.3333M19.3333 23.6667L19.3333 19.6667M16.6667 10.3335C16.6667 10.3335 16.1005 10.4143 13.7574 12.7575C11.4142 15.1006 11.4142 18.8996 13.7574 21.2428C14.5875 22.073 15.6005 22.609 16.6667 22.8509M16.6667 10.3335L12.6667 10.3333M16.6667 10.3335L16.6667 14.3333" stroke="#424242" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                    <defs>
                      <filter id="ppf1" x="0" y="0" width="36" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix>
                        <feOffset dy="1"></feOffset>
                        <feGaussianBlur stdDeviation="1"></feGaussianBlur>
                        <feComposite in2="hardAlpha" operator="out"></feComposite>
                        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"></feColorMatrix>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
                      </filter>
                    </defs>
                  </g>
                </svg>
              </div>
              <div>
                <div class="cd-pp-modal__item-title">Free returns & exchanges</div>
                <div class="cd-pp-modal__item-text">
                  Return or exchange your items for free. If you're not completely satisfied, we've got you covered.
                </div>
              </div>
            </div>

            <div class="cd-pp-modal__item">
              <div class="cd-pp-modal__icon">
                <svg width="32" height="32" viewBox="0 0 36 36" fill="none" aria-hidden="true">
                  <g filter="url(#ppf2)">
                    <path d="M2.5 7C2.5 3.96243 4.96243 1.5 8 1.5H28C31.0376 1.5 33.5 3.96243 33.5 7V27C33.5 30.0376 31.0376 32.5 28 32.5H8C4.96243 32.5 2.5 30.0376 2.5 27V7Z" stroke="#D6D6D6"/>
                    <path d="M23.6666 13.8518L18 17M18 17L12.3333 13.8518M18 17L18 23.3333M19.3333 22.9259L18.518 23.3789C18.329 23.4839 18.2344 23.5364 18.1343 23.557C18.0457 23.5753 17.9543 23.5753 17.8657 23.557C17.7656 23.5364 17.6711 23.4839 17.482 23.3789L12.5486 20.6381C12.349 20.5272 12.2491 20.4717 12.1764 20.3928C12.1121 20.3231 12.0634 20.2403 12.0337 20.1502C12 20.0483 12 19.9341 12 19.7057V14.2943C12 14.0659 12 13.9517 12.0337 13.8498C12.0634 13.7597 12.1121 13.677 12.1764 13.6072C12.2491 13.5283 12.349 13.4728 12.5486 13.3619L17.482 10.6211C17.671 10.5161 17.7656 10.4636 17.8657 10.443C17.9543 10.4248 18.0457 10.4248 18.1343 10.443C18.2344 10.4636 18.329 10.5161 18.518 10.6211L23.4514 13.3619C23.651 13.4728 23.7509 13.5283 23.8236 13.6072C23.8879 13.6769 23.9366 13.7597 23.9663 13.8498C24 13.9517 24 14.0659 24 14.2943L24 17.3333M15 12L21 15.3333M20.6667 21L22 22.3333L24.6667 19.6667" stroke="#424242" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                    <defs>
                      <filter id="ppf2" x="0" y="0" width="36" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix>
                        <feOffset dy="1"></feOffset>
                        <feGaussianBlur stdDeviation="1"></feGaussianBlur>
                        <feComposite in2="hardAlpha" operator="out"></feComposite>
                        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"></feColorMatrix>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
                      </filter>
                    </defs>
                  </g>
                </svg>
              </div>
              <div>
                <div class="cd-pp-modal__item-title">Package protection</div>
                <div class="cd-pp-modal__item-text">
                  Rest assured, if your package is lost, stolen, or damaged, we've got you covered.
                </div>
              </div>
            </div>

            <div class="cd-pp-modal__item">
              <div class="cd-pp-modal__icon">
                <svg width="32" height="32" viewBox="0 0 36 36" fill="none" aria-hidden="true">
                  <g filter="url(#ppf3)">
                    <path d="M2.5 7C2.5 3.96243 4.96243 1.5 8 1.5H28C31.0376 1.5 33.5 3.96243 33.5 7V27C33.5 30.0376 31.0376 32.5 28 32.5H8C4.96243 32.5 2.5 30.0376 2.5 27V7Z" stroke="#D6D6D6"/>
                    <path d="M23.9999 19.6667V13.8C23.9999 13.0533 23.9999 12.6799 23.8546 12.3947C23.7268 12.1438 23.5228 11.9398 23.2719 11.812C22.9867 11.6667 22.6133 11.6667 21.8666 11.6667H14.1333C13.3865 11.6667 13.0131 11.6667 12.7279 11.812C12.477 11.9398 12.2731 12.1438 12.1452 12.3947C11.9999 12.6799 11.9999 13.0533 11.9999 13.8V19.6667M13.111 22.3333H22.8888C23.3021 22.3333 23.5088 22.3333 23.6783 22.2879C24.1385 22.1646 24.4979 21.8052 24.6212 21.3451C24.6666 21.1755 24.6666 20.9689 24.6666 20.5556C24.6666 20.3489 24.6666 20.2456 24.6439 20.1608C24.5822 19.9307 24.4025 19.751 24.1725 19.6894C24.0877 19.6667 23.9844 19.6667 23.7777 19.6667H12.2221C12.0155 19.6667 11.9122 19.6667 11.8274 19.6894C11.5973 19.751 11.4176 19.9307 11.356 20.1608C11.3333 20.2456 11.3333 20.3489 11.3333 20.5556C11.3333 20.9689 11.3333 21.1755 11.3787 21.3451C11.502 21.8052 11.8614 22.1646 12.3215 22.2879C12.491 22.3333 12.6977 22.3333 13.111 22.3333Z" stroke="#424242" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                    <defs>
                      <filter id="ppf3" x="0" y="0" width="36" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix>
                        <feOffset dy="1"></feOffset>
                        <feGaussianBlur stdDeviation="1"></feGaussianBlur>
                        <feComposite in2="hardAlpha" operator="out"></feComposite>
                        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"></feColorMatrix>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
                      </filter>
                    </defs>
                  </g>
                </svg>
              </div>
              <div>
                <div class="cd-pp-modal__item-title">Easy return portal</div>
                <div class="cd-pp-modal__item-text">
                  Skip all the back and forth, and submit your return in a few clicks.
                </div>
              </div>
            </div>
          </div>

          <p class="cd-pp-modal__legal">
            By purchasing coverage, you agree and have read the
            <a href="https://www.getredo.com/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a>
            and
            <a href="https://www.getredo.com/terms-conditions" target="_blank" rel="noreferrer">Terms and Conditions</a>.
            Coverage is subject to Merchant's Return Policy.
          </p>
        </div>
      `;

      document.body.appendChild(modal);
    }

    bindPackageProtectionInfo();
  }

  function bindPackageProtectionInfo() {
    const modal = document.getElementById('cd-pp-info-modal');
    const openBtn = document.querySelector('.cd-pp-info-btn');
    if (!modal || !openBtn) return;

    if (openBtn.dataset.bound === 'true') return;
    openBtn.dataset.bound = 'true';

    function openModal() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('cd-pp-modal-open');
      document.body.classList.add('cd-pp-modal-open');
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('cd-pp-modal-open');
      document.body.classList.remove('cd-pp-modal-open');
    }

    openBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openModal();
    });

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-pp-modal-close]')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
  }

  const style = document.createElement('style');
  style.innerHTML = `
    .cd-pp-name {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .cd-pp-info-btn {
        width: 10px;
        height: 15px;
        min-width: 15px;
        border-radius: 50%;
        border: 2px solid rgb(213, 213, 213);
        background: transparent;
        color: #8e8e8e;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-family: Arial, sans-serif;
        font-size: 8px;
        font-weight: 500;
        line-height: 1;
        cursor: pointer;
        padding: 0;
        margin-left: 6px;
        position: relative;
        bottom: 2px;
    }

    .cd-pp-modal {
      position: fixed;
      inset: 0;
      z-index: 10050;
      display: none;
    }

    .cd-pp-modal.is-open {
      display: block;
    }

    .cd-pp-modal__backdrop {
      position: absolute;
      inset: 0;
      background: rgba(0, 0, 0, 0.42);
    }

    .cd-pp-modal__dialog {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: min(92vw, 560px);
      max-height: min(86vh, 760px);
      overflow-y: auto;
      background: #fff;
      border-radius: 18px;
      padding: 28px 24px 22px;
      box-sizing: border-box;
      box-shadow: 0 20px 60px rgba(0,0,0,.18);
      font-family: 'Poppins', sans-serif;
      color: #1a1a1a;
    }

    .cd-pp-modal__close {
      position: absolute;
      top: 14px;
      right: 14px;
      width: 36px;
      height: 36px;
      border: none;
      background: transparent;
      color: #555;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 0;
    }

    .cd-pp-modal__logo {
      display: flex;
      justify-content: start;
      margin-bottom: 10px;
    }

    .cd-pp-modal__logo img {
      max-width: 120px;
      height: auto;
      display: block;
    }

    .cd-pp-modal__title {
      margin: 0;
      text-align: start;
      font-size: 20px;
      line-height: 1.15;
      font-weight: 600;
      color: #111;
    }

    .cd-pp-modal__subtitle {
      margin: 10px 0 22px;
      text-align: start;
      font-size: 14px;
      line-height: 1.55;
      font-weight: 300;
      color: #4a4a4a;
    }

    .cd-pp-modal__list {
      display: flex;
      flex-direction: column;
      gap: 18px;
    }

    .cd-pp-modal__item {
      display: grid;
      grid-template-columns: 32px 1fr;
      gap: 14px;
      align-items: start;
    }

    .cd-pp-modal__icon {
      line-height: 0;
    }

    .cd-pp-modal__item-title {
      font-size: 16px;
      line-height: 1.35;
      font-weight: 600;
      color: #111;
      margin-bottom: 4px;
    }

    .cd-pp-modal__item-text {
      font-size: 12px;
      line-height: 1.55;
      font-weight: 300;
      color: #6b6b6b;
    }

    .cd-pp-modal__legal {
      margin: 22px 0 0;
      font-size: 12px;
      line-height: 1.55;
      font-weight: 300;
      color: #6b6b6b;
    }

    .cd-pp-modal__legal a {
      color: rgb(0, 0, 255);
      text-decoration: underline;
    }

    html.cd-pp-modal-open,
    body.cd-pp-modal-open {
      overflow: hidden;
    }

    @media (max-width: 640px) {
      .cd-pp-modal__dialog {
        width: calc(100vw - 24px);
        padding: 24px 18px 20px;
        border-radius: 16px;
      }

      .cd-pp-modal__title {
        font-size: 20px;
      }
    }
  `;
  document.head.appendChild(style);



  let ppUserInteracted = false;
  let ppDesiredState = false;
  let ppCleanupRunning = false;

  function getPPToggles() {
    return Array.from(document.querySelectorAll('[data-pp-toggle]'));
  }

  function isPPToggleOn(toggle) {
    return !!toggle && (toggle.classList.contains('on') || toggle.getAttribute('aria-checked') === 'true');
  }

  function setPPToggleState(toggle, enabled) {
    if (!toggle) return;

    toggle.classList.toggle('on', !!enabled);
    toggle.setAttribute('aria-checked', enabled ? 'true' : 'false');
    toggle.dataset.ppUserSelected = enabled ? 'true' : 'false';
  }

  function setAllPPTogglesState(enabled) {
    getPPToggles().forEach(function (toggle) {
      setPPToggleState(toggle, enabled);
    });
  }

  function forcePPDefaultOff() {
    if (ppUserInteracted) return;
    setAllPPTogglesState(false);
  }

  function getPPVariantId(toggle) {
    return Number(toggle?.dataset?.ppVariant || 0);
  }

  function fetchCart() {
    return fetch('/cart.js', {
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart request failed');
      return res.json();
    });
  }

  function notifyCartUpdated(cart) {
    document.dispatchEvent(new CustomEvent('cart:updated', {
      bubbles: true,
      detail: { cart: cart }
    }));

    document.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { cart: cart }
    }));

    window.dispatchEvent(new CustomEvent('cart:refresh', {
      detail: { cart: cart }
    }));
  }

  function findPackageProtectionItem(cart, variantId) {
    const items = Array.isArray(cart?.items) ? cart.items : [];

    return items.find(function (item) {
      const handleMatch = String(item.handle || '').toLowerCase() === 'package-protection';
      const variantMatch = variantId && Number(item.variant_id) === Number(variantId);
      return handleMatch || variantMatch;
    }) || null;
  }

  function changeCartLine(id, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: id,
        quantity: quantity
      })
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart change failed');
      return res.json();
    });
  }

  function addPackageProtection(toggle) {
    const variantId = getPPVariantId(toggle);
    if (!variantId) return Promise.reject(new Error('Missing package protection variant ID'));

    return fetchCart()
      .then(function (cart) {
        const existing = findPackageProtectionItem(cart, variantId);
        if (existing) return cart;

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
                properties: {
                  _package_protection: 'true'
                }
              }
            ]
          })
        }).then(function (res) {
          if (!res.ok) throw new Error('Package protection add failed');
          return fetchCart();
        });
      })
      .then(function (cart) {
        const item = findPackageProtectionItem(cart, variantId);
        if (item && toggle) {
          toggle.dataset.ppKey = item.key || '';
          toggle.dataset.ppPrice = item.final_price || item.price || toggle.dataset.ppPrice || '';
        }
        return cart;
      });
  }

  function removePackageProtection(toggle) {
    const variantId = getPPVariantId(toggle);
    const currentKey = toggle?.dataset?.ppKey || '';

    return fetchCart()
      .then(function (cart) {
        const item = findPackageProtectionItem(cart, variantId);
        const id = currentKey || item?.key || '';
        if (!id) return cart;
        return changeCartLine(id, 0);
      })
      .then(function (cart) {
        if (toggle) toggle.dataset.ppKey = '';
        return cart;
      });
  }

  function cleanupDefaultPackageProtection() {
    if (ppUserInteracted || ppCleanupRunning) return;

    const toggle = document.querySelector('[data-pp-toggle]');
    if (!toggle) return;

    const variantId = getPPVariantId(toggle);
    ppCleanupRunning = true;

    fetchCart()
      .then(function (cart) {
        const item = findPackageProtectionItem(cart, variantId);
        if (!item) return cart;
        return changeCartLine(item.key, 0);
      })
      .then(function (cart) {
        forcePPDefaultOff();
        notifyCartUpdated(cart);
      })
      .catch(function (error) {
        console.warn('[PackageProtection] Default cleanup failed:', error);
        forcePPDefaultOff();
      })
      .finally(function () {
        ppCleanupRunning = false;
      });
  }

  function bindPackageProtectionToggle() {
    getPPToggles().forEach(function (toggle) {
      if (toggle.dataset.ppClickOnlyBound === 'true') return;
      toggle.dataset.ppClickOnlyBound = 'true';
      setPPToggleState(toggle, false);
    });
  }

  document.addEventListener('click', function (event) {
    const toggle = event.target.closest('[data-pp-toggle]');
    if (!toggle) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (toggle.dataset.ppBusy === 'true') return;

    ppUserInteracted = true;
    ppDesiredState = !isPPToggleOn(toggle);

    toggle.dataset.ppBusy = 'true';
    toggle.disabled = true;
    setAllPPTogglesState(ppDesiredState);

    const action = ppDesiredState ? addPackageProtection(toggle) : removePackageProtection(toggle);

    action
      .then(function (cart) {
        setAllPPTogglesState(ppDesiredState);
        notifyCartUpdated(cart);
      })
      .catch(function (error) {
        console.warn('[PackageProtection] Toggle failed:', error);
        ppDesiredState = !ppDesiredState;
        setAllPPTogglesState(ppDesiredState);
      })
      .finally(function () {
        getPPToggles().forEach(function (item) {
          item.dataset.ppBusy = 'false';
          item.disabled = false;
        });
      });
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    bindPackageProtectionToggle();
    forcePPDefaultOff();
    cleanupDefaultPackageProtection();
  });

  document.addEventListener('DOMContentLoaded', initPackageProtectionInfo);

  const observer = new MutationObserver(function () {
    initPackageProtectionInfo();
    bindPackageProtectionToggle();

    if (ppUserInteracted) {
      setAllPPTogglesState(ppDesiredState);
    } else {
      forcePPDefaultOff();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();